import React, { useState } from "react";
import { fetchData } from "../../networkRequests";
import {
  Button,
  Input
} from "reactstrap";
import LoadingArrow from "../../../../images/login/loading_arrow.gif";


const SpinngingGIF = () => {
  return <img style={{ maxHeight: 25, maxWidth: "100%" }} src={LoadingArrow} />
}


export const QRCodeLogin = ({ setusername, setpassword, setstrokes, props, remoteip, portal }) => {

  let [isSendingOTP, setisSendingOTP] = useState(false);
  let [otpsent, setotpsent] = useState(false);
  let [mobile, setmobile] = useState(false);
  return (
    <span>
      <div className="col-sm-12">
        <Input
          autoComplete="off"
          placeholder="App Login ID"
          name="qrloginid"
          autoFocus="autofocus"
          readOnly={true}
          onChange={e => this.setState({ qrloginid: e.target.value })
          }
          style={{ marginTop: 10 }}
          type="text"
          value={this.state.qrloginid}
          onKeyDown={this.onkeyPressDown}
        // onKeyPress={(event) => this.handleKeyPress('password', event)}
        />
      </div>
      <div style={{ textAlign: "right", height: 20, color: "#990000", fontSize: 10, paddingTop: 3 }} id="caps-lock-message"></div>
      <div className="col-sm-12">
        <Input
          autoComplete="new-password"
          placeholder="Password"
          name="qrpasscode"
          autoComplete="false"
          onChange={this.handleQRPasscodeChange}
          type="text"
          className="txtPassword"
          onKeyDown={this.onkeyPressDown}
          value={this.state.qrpasscode}
        />
      </div>
    </span>



  )
}